window.fsTimekit = window.fsTimekit || {};
window.fsTimekit.selectedBooking = null;
window.fsTimekit.client = {

	/**
	 * Create booking in TimeKit (via local proxy API)
	 *
	 * @param {*} data
	 * @returns
	 */
	createBooking: async (data) => {
		// Default options are marked with *
		const response = window.fetch(window.fsTimekit.restUrl, {
			method: 'POST',
			mode: 'cors',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json'
			},
			redirect: 'follow',
			body: JSON.stringify(data)
		});

		return response;
	},

	/**
	 * Checks availability of store (resource) timeslots.
	 *
	 * @param {*} resourceId
	 * @returns
	 */
	getAvailability: async ( resourceId ) => {

		// Default options are marked with *
		const response = await window.fetch(window.fsTimekit.restUrl + '?resource_id=' + resourceId, {
			method: 'GET',
			mode: 'cors',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json'
			},
		});
		const data = await response.json();
		return JSON.parse(data);
	}
};

document.addEventListener('DOMContentLoaded', function() {
	let calendarTarget = document.getElementById('timekit-calendar');

	if ( null === calendarTarget ) {
		return;
	}

	// Retrieve available timeSlots, one-hour increments, 12 weeks into the future.
	const availabilityData = window.fsTimekit.client.getAvailability(window.fsTimekit.resourceId);

	// Renders time slots based on selected date (or first available date on page load)
	const updateTimeSlots = ( date, data ) => {

		let timeActionsEl = document.querySelector( '.time-options' );

		// Timeslots available, scoped to the specific day represented by `date`
		const scopedData = data.filter( (availableDate) => {
			let availabilityDateObject = new Date( availableDate.start );

			return (
				date.getYear() === availabilityDateObject.getYear() &&
				date.getMonth() === availabilityDateObject.getMonth() &&
				date.getDate() === availabilityDateObject.getDate()
			)
		} );

		timeActionsEl.innerHTML = '';

		if ( ! scopedData.length ) {
			return;
		}

		scopedData.forEach( ( timeSlot, index ) => {

			let startTimeObject = new Date(timeSlot.start);
			let startTimeString = startTimeObject.toLocaleTimeString( 'en-US', { timeZone: timeSlot.resources[0].timezone }).replace( '00:00', '00' );
			let startDateString = startTimeObject.toLocaleDateString( 'en-US', { timeZone: timeSlot.resources[0].timezone });

			console.log(startDateString);

			if ( ! index ) {
				window.fsTimekit.selectedBooking = timeSlot;
				timeActionsEl.innerHTML += '<div class="time selected" data-start="' + timeSlot.start + '" data-end="' + timeSlot.end + '" data-timezone="' + timeSlot.resources[0].timezone + '"><span>' + startTimeString + '</span></div>';
				window.fsTimekit.selectedBooking = document.querySelector( 'div.time.selected' );
			} else {
				timeActionsEl.innerHTML += '<div class="time" data-start="' + timeSlot.start + '" data-end="' + timeSlot.end + '" data-timezone="' + timeSlot.resources[0].timezone + '"><span>' + startTimeString + '</span></div>';
			}
		});

		let timeSlots = document.querySelectorAll( '.time-options .time' );

		timeSlots.forEach( time => {

			time.addEventListener( 'click', (evt) => {
				if ( evt.target.classList.contains( 'selected' ) ) {
					return;
				}

				let selected = document.querySelector( '.time-options .selected' );

				if ( selected !== null ) {
					selected.classList.remove('selected');
				}

				evt.target.parentNode.classList.add('selected');

				let bookingTimes = document.querySelectorAll( '.booking-time' );

				window.fsTimekit.selectedBooking = time;

				bookingTimes.forEach( element => {
					element.innerText = evt.target.innerText;
				} );
			} );
		} )
			
		// Render the default selected time on each load.
		let defaultSelectedTime = document.querySelector('.time.selected span');
		let defaultBookingTime = document.querySelectorAll('.booking-time');
		if ( null !== defaultBookingTime && null !== defaultSelectedTime ) {
			defaultBookingTime.forEach((timeSlot, index) => {
				timeSlot.innerHTML = defaultSelectedTime.innerHTML;
			});	
		}
	};


	// Updates booking dates in DOM on page load and date selection.
	const updateBookingDate = ( date, data ) => {
		let bookingDates = document.querySelectorAll( '.booking-date' );

		bookingDates.forEach( element => {
			element.innerText = new Date( date ).toLocaleDateString( 'en-US', { month: 'long', day: 'numeric', year: 'numeric' } );
		} );
	};

	// STEP ONE: Once availability is retrieved, generate jsCalendar
	availabilityData.then( ( response ) => {
		let startDate = new Date( response.data[0].start );
		let calendar = jsCalendar.new(
			calendarTarget,
			startDate,
			{
				min: startDate,
				max: new Date( response.data[response.data.length - 1].start)
			}
		);

		updateBookingDate( startDate, response.data );
		updateTimeSlots( startDate, response.data );

		// Mark dates as available if they are indeed available.
		calendar.onDateRender(function(date, element, info) {

			if ( info.isCurrent ) {
				element.classList.add('selected');
			}

			response.data.map( (availableDate) => {
				let availabilityDateObject = new Date( availableDate.start );

				if (
					! element.classList.contains( 'available' ) &&
					date.getYear() === availabilityDateObject.getYear() &&
					date.getMonth() === availabilityDateObject.getMonth() &&
					date.getDate() === availabilityDateObject.getDate()
				) {
					element.classList.add( 'available' );
				}
			} );

		});

		// Select date and fill timeslots
		calendar.onDateClick(function(event, date){

			const { target } = event;

			if ( target.classList.contains( 'available' ) ) {
				let selected = target.parentNode.parentNode.querySelector( '.selected' );
				if ( selected !== null ) {
					selected.classList.remove('selected');
				}
				target.classList.add('selected');

				updateBookingDate( date, response.data );
				updateTimeSlots( date, response.data );
			}
		});

		calendar.refresh();
	} );

	// STEP ONE > STEP TWO (Select and Continue)
	document.querySelector( '.time-actions .btn' ).addEventListener( 'click', (evt) => {
		document.querySelector( '.step-one' ).style.display = 'none';
		document.querySelector( '.step-two' ).style.display = 'block';
	} );

	// STEP TWO > STEP ONE (Cancel)
	document.querySelector( '.step-two .form-actions .text-link' ).addEventListener( 'click', (evt) => {
		document.querySelector( '.step-one' ).style.display = 'block';
		document.querySelector( '.step-two' ).style.display = 'none';
	} );

	// STEP TWO > STEP THREE (Create Booking)
	document.querySelector( '.step-two .form-actions .btn' ).addEventListener( 'click', (evt) => {
		let form = document.querySelector( '.step-two form' );

		if ( ! form.checkValidity() ) {
			return form.reportValidity();
		}

		window.fsTimekit.client.createBooking({
			city: window.fsTimekit.locationCity,
			resource_id: window.fsTimekit.resourceId,
			start: window.fsTimekit.selectedBooking.dataset.start,
			end: window.fsTimekit.selectedBooking.dataset.end,
			timezone: window.fsTimekit.selectedBooking.dataset.timezone,
			first_name: document.getElementById( 'first-name' ).value,
			last_name: document.getElementById( 'last-name' ).value,
			phone: document.getElementById( 'tel' ).value,
			email: document.getElementById( 'email-address' ).value,
			reason: document.querySelector( '.radio-options input:checked' ).value,
		}).then( (response) => {
			document.querySelector( '.step-two' ).style.display = 'none';
			document.querySelector( '.step-three' ).style.display = 'block';
		} );

	} );

	// STEP TWO: Reason (show/hide text)
	const reasonRadios = document.querySelectorAll( '.step-two input[type="radio"]' );
	const hiddenText = document.querySelector( '.step-two .radio-options p.small' );

	reasonRadios.forEach( reason => {

		reason.addEventListener( 'change', (evt) => {
			if ( evt.target.id === 'reason-medicare' ) {
				hiddenText.style.visibility = 'visible';
			} else {
				hiddenText.style.visibility = 'hidden';
			}

		} );
	} );

} );
